/**
 * AssetTypeCell
 *
 * Renders a small badge labelling each row's categorical asset kind
 * ('Application', 'Web Application', 'IP', 'Domain', 'Other'). Derived
 * via the shared `assetType()` util so this is consistent with the
 * drawer header and any future labelling.
 *
 * Uses the shadcn `Badge` primitive — brand-token classes only, no hex.
 * Applications get the `default` (primary/crimson) variant; everything
 * else gets `secondary` so the rollup root stands out at a glance.
 *
 * See rollup-frontend-plan.md item C.
 */
import React from 'react';

import { Badge } from '@/components/ui/badge';
import { ASSET_TYPE_LABEL, assetType } from '@/sections/asset/utils';
import type { Asset } from '@/types';

interface AssetTypeCellProps {
  asset: Asset;
}

export const AssetTypeCell: React.FC<AssetTypeCellProps> = ({ asset }) => {
  const kind = assetType(asset);
  const variant = kind === 'application' ? 'default' : 'secondary';

  return (
    <Badge variant={variant} className="font-normal">
      {ASSET_TYPE_LABEL[kind]}
    </Badge>
  );
};
